import { IRunAllSessionsUseCase } from '../../interfaces/use-cases/IRunAllSessionsUseCase';
import { ISessionManager } from '../../interfaces/core/ISessionManager';
import { ISessionExecutor } from '../../interfaces/core/ISessionExecutor';
import { SessionResult, SessionExecutionResult } from '../../interfaces/results/SessionResult';

export class RunAllSessionsUseCase implements IRunAllSessionsUseCase {
  constructor(
    private sessionManager: ISessionManager,
    private sessionExecutor: ISessionExecutor
  ) {}

  async execute(): Promise<SessionResult[]> {
    const sessions = this.sessionManager.getAllSessions();
    const results: SessionResult[] = [];

    for (const session of sessions) {
      if (!session.completed) {
        try {
          const result = await this.sessionExecutor.execute(session);
          const sessionExecutionResult: SessionExecutionResult = {
            ...result,
            label: result.sessionLabel,
            passes: result.stats.passes,
            failures: result.stats.failures,
            tests: result.stats.tests
          };
          results.push({
            label: session.label,
            result: sessionExecutionResult
          });
        } catch (error) {
          results.push({
            label: session.label,
            result: null,
            error: error instanceof Error ? error.message : String(error)
          });
        }
      }
    }

    return results;
  }
}
